import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Button, Carousel, Skeleton } from '../../../../components/ui';
import ProductCard from '../../../../components/ProductCard';
import styles from './SuggestionsForYou.module.css';

export default function SuggestionsForYou({
  products = [],
  loading,
  productsFavoritos = [],
  onToggleFavorite
}) {
  const { t } = useTranslation('home');

  if (loading) {
    return (
      <section className={styles.root}>
        <div className={styles.skeletonHead}>
          <h2 className={styles.title}>{t('SUGGESTIONS_TO_YOU')}</h2>
        </div>
        <div className={styles.skeletonGrid}>
          {Array.from({ length: 4 }).map((_, i) => (
            <Skeleton key={i} height={300} radius='var(--ui-radius)' />
          ))}
        </div>
        <div className={styles.cta}>
          <Button
            variant='primary'
            size='md'
            as={Link}
            to='/catalogo'
            className={styles.ctaBtn}>
            {t('SEE_ALL')}
          </Button>
        </div>
      </section>
    );
  }

  if (!products || products.length === 0) return null;

  const favEntityId = p => {
    switch (p.tipo) {
      case 'CONSULTORIA':
        return p.id;
      case 'CURSO':
        return p.curso && p.curso.id;
      case 'SEBRAETEC_FICHA_TECNICA':
        return p.sebraetecFichaTecnica && p.sebraetecFichaTecnica.id;
      default:
        return null;
    }
  };

  const isFav = p => {
    const id = favEntityId(p);
    return !!id && productsFavoritos.includes(id);
  };

  return (
    <section className={styles.root}>
      <Carousel
        className={styles.carousel}
        header={<h2 className={styles.title}>{t('SUGGESTIONS_TO_YOU')}</h2>}
        slidesToShow={{ base: 4, xl: 3, lg: 2, sm: 1 }}
        gap={25}
        infinite
        autoplay
        dots={false}
        prevLabel={t('SUGGESTIONS_PREV')}
        nextLabel={t('SUGGESTIONS_NEXT')}>
        {products.map(p => (
          <div key={p.id} className={styles.slide}>
            <ProductCard
              product={p}
              isFavorito={isFav(p)}
              onToggleFavorite={onToggleFavorite}
            />
          </div>
        ))}
      </Carousel>
      <div className={styles.cta}>
        <Button
          variant='primary'
          size='md'
          as={Link}
          to='/catalogo'
          className={styles.ctaBtn}>
          {t('SEE_ALL')}
        </Button>
      </div>
    </section>
  );
}

SuggestionsForYou.propTypes = {
  products: PropTypes.array,
  loading: PropTypes.bool,
  productsFavoritos: PropTypes.array,
  onToggleFavorite: PropTypes.func
};
